import React, {PureComponent} from "react"
import {Row, Col} from "react-bootstrap"

import {Card} from "@irati/ui/src/Layout"
import {H2} from "@irati/ui/src/Headings"
import {Label1, Label2} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"

export default class ResetPasswordError extends PureComponent {
  render() {
    return (
      <Row>
        <Col xs={12} smOffset={3} sm={6}>
          <Card className="push--top text-center">
            <H2 medium><FormattedMessage id="platform.oops.header.text" /></H2>
            <Label1>
              <FormattedMessage id="platform.resetPassword.header.text" />
            </Label1>
            <div className="push--top">
              <Label2>
                <FormattedMessage id="platform.resetPassword.header.safari" />
              </Label2>
            </div>
          </Card>
        </Col>
      </Row>
    )
  }
}
